/**Multiselector de varias guias */

import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { addDate, truncateDate, all, allEqual, intersectKeys, toObservable, nullsafe, shallowEquals } from "keautils";
import { MultiselectorGuiaList } from "./list";
import { FiltroGuiaComponent } from "./filtro";

export interface Props {
    /**Folios de las guias seleccionadass¿ */
    value: string[];
    filtro: Partial<models.FiltroGuia>;
    onChange: (value: string[]) => void;
    onFiltroChange: (filtro: models.FiltroGuia) => void;
    idSucursalUsuario?: number | null;
}


class MultiselectorGuiasNoRx extends React.PureComponent<Props> {

    /**Función que carga las guias */
    loadFunction = kea.loadItemsFuncFromResource(
        filtro => observeResource(resources.Guia.Query, filtro),
        id => observeResource(resources.Guia.Get, id),
        x => x.Folio,
        x => true);

    usuario = (props: Props) => resources.User.SessionRx;
    permisosFiltroSucursal = createSelectorRx(this.usuario, usuario => ({
        verOtrasSucursales: usuario.Permisos.EntregaOcurre.MostrarGuiasSucursalDiferenteUsuario,
        idSucursal: usuario.IdSucursal
    }));


    filtro = (props: Props) => props.filtro;

    filtroEff = createSelectorRx(this.filtro, this.permisosFiltroSucursal, (filtro, permisos) => ({
        ...filtro,
        entregada: false,
        enSucursalDestino: true,
        IdSucursalDestino: permisos.verOtrasSucursales ? undefined : permisos.idSucursal
        //TODO: Filtrar las que estan listas para entregar
    } as models.FiltroGuia));

    value = (props: Props) => props.value;
    guias = createSelectorRx(this.filtroEff, this.value, (filtro, value) => this.loadFunction(filtro as models.FiltroGuia, value));
    selected = createSelectorRx(this.guias, this.value, (guias, value) => intersectKeys(guias, value, x => x.Folio));
    mismoDestino = createSelectorRx(this.selected, guias => {
        const ret = allEqual(guias.map(x => ({ clienteDestino: x.IdClienteDestino, sucDestino: x.IdSucursalDestino })), shallowEquals);
        return ret;
    });

    error = createSelectorRx(this.mismoDestino, x => x ? undefined : "Todas las guias deben de estar dirigidas al mismo destino");

    render() {
        const guias = this.guias(this.props);
        const selected = this.value(this.props);
        const error = this.error(this.props);
        const filtro = this.filtroEff(this.props);
        return (
            <div>
                <FiltroGuiaComponent value={filtro} onChange={this.props.onFiltroChange} />
                <kea.Title titulo="Guias" size="h4" error={error} />
                <MultiselectorGuiaList items={guias} value={selected} onChange={this.props.onChange} />
            </div>
        )
    }
}

const now = truncateDate(new Date(), "days");
export const MultiselectorGuias = kea.defaultProps(componentToRx(kea.mapProps<Props>(MultiselectorGuiasNoRx, x => ({
    ...x,
    filtro: { FechaInicio: addDate(now, "days", -7), ...x.filtro },
}))), {
        idSucursalUsuario: resources.User.IdSucursalRx
    });


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/ocurre/componentes/multiguias/index.tsx